import { history } from './history'
import { userService } from '../_services' 

export const redirectMiddleware = store => next => action => {
    //intercept redux action and handle error redirection 

    return next(action);
}



// WEBPACK FOOTER //
// ./src/_helpers/redirectMiddleware.js